import { useState } from 'react';

import useLocalStorage from './useLocalStorage';
import { useQueryParams } from './useQueryParams';

export default function useAppProvider() {
  const urlSearch = useQueryParams();
  const hasQueryAccessToken = !!urlSearch.get('at');

  const {
    localStorageData: { accessToken }
  } = useLocalStorage();
  const [auth, setAuth] = useState(!!accessToken || hasQueryAccessToken);
  const [ready, setReady] = useState(false);
  const [userInfo, setUserInfo] = useState(null);

  return {
    auth,
    setAuth,
    ready,
    setReady,
    userInfo,
    setUserInfo
  };
}
